<template>
    <div class="accept-terms vbox align-center ob-card">
        <form @submit.prevent="submit" method="PUT" accept-charset="UTF-8" novalidate="novalidate">
            <div class="row">
                <br>
                <div class="col-sm-12 form-group has-feedback"
                    :class="{'has-error': errors.has('accept_terms')}">
                    <input id="user-accept-terms"
                            v-model="acceptTerms"
                            name="accept_terms"
                            type="checkbox"
                            class="form-control"
                            style="float: left;">

                    <label for="user-accept-terms">
                        &nbsp; I accept the
                        <a href="/terms" target="_blank">Terms &amp; Conditions</a>
                        and
                        <a href="/privacy-policy" target="_blank">Privacy Policy</a>
                    </label>

                    <span v-show="errors.has('accept_terms')" class="help-block">
                        {{ errors.first('accept_terms') }}
                    </span>
                </div>
            </div>

            <hr>

            <div class="col-xs-6 form-group hbox justify-center full-width">
                <button type="submit" class="btn btn-success btn-block" :disabled="loading">
                    Submit
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        props: {
            user: {
                required: true,
                type: Object
            },

            appUrl: {
                required: true,
                type: String
            },
        },

        data() {
            return {
                loading: false,
                acceptTerms: false
            };
        },

        methods: {
            submit() {
                this.loading = true;
                this.errors.clear();

                return this.$validator.validateAll()
                    .then( ( valid ) => {
                        if ( valid ) {
                            return axios.put( '/users/' + this.user.id + '/acceptTerms', {
                                AcceptTerms: this.acceptTerms
                            } )
                                .then( ( response ) => {
                                    if ( response.data.error ) {
                                        this.$notify( {
                                            type: 'danger',
                                            placement: 'top-left',
                                            title: response.data.error,
                                        } );
                                    } else {
                                        window.location.href = this.appUrl + "/dashboard";
                                    }
                                } )
                                .catch( this.$root.handleErrors )
                                .finally( () => {
                                    this.loading = false;
                                } );
                        } else {
                            this.loading = false;
                        }
                    } );
            }
        }
    }
</script>
